var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03638 4.2939C3.01168 4.10866 3.07629 3.92338 3.22852 3.81499C3.92439 3.31953 6.31139 2 11.9972 2C17.683 2 20.07 3.31952 20.7659 3.81499C20.9181 3.92338 20.9827 4.10866 20.958 4.2939L19.2588 17.0378C19.094 18.2744 18.3616 19.3632 17.2785 19.9821L16.9586 20.1649C13.8843 21.9217 10.1101 21.9217 7.0358 20.1649L6.71592 19.9821C5.63279 19.3632 4.90044 18.2744 4.73557 17.0378L3.03638 4.2939Z",
    stroke: "#21272A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5C5.57143 7.66666 18.4286 7.66662 21 5",
    stroke: "#21272A",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.5L20 11.5M11 18L14 14.5L11 18ZM14 14.5L19 17L14 14.5Z",
    stroke: "#21272A",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.9996L7.73595 15.5373C7.90405 15.5133 8.07446 15.5616 8.20491 15.6704L11 17.9996L14 20.9996",
    stroke: "#21272A",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5005L10.6149 12.4498C10.8284 12.2006 11.2025 12.1693 11.4546 12.3793L14 14.5005",
    stroke: "#21272A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.5f96b333752acb688ecd92e00f0e14a6.svg";
export { ForwardRef as ReactComponent };